import reduce from 'lodash/fp/reduce'
import { deviceTypes } from './device-type'


const fields = {
    DEVICE_TYPE: 'deviceType'
}

export const initialValues = reduce((acc, field) => ({
    ...acc,
    [field]: field === 'deviceType' ? deviceTypes.IPHONE : ''
}), {}, Object.values(fields))

export default fields
